import PropTypes from 'prop-types'
import React from 'react'
import Space from 'ui/Space'
import SubmitField from 'ui/SubmitField'
import { Button, Display5, Body1 } from '@segment/react-ui-library'
import { Form, InputField } from '@segment/react-forms'
import ShowHide from 'ui/ShowHide'
import Table from 'ui/Table2'
import CopyButton from 'ui/CopyButton'
import getProp from '@f/get-prop'
import Alert from 'ui/Alert'
import css from './CustomersSettings.module.css'

const COLUMNS = [
  { label: 'Name', name: 'name' },
  { label: 'Access Key', name: 'accessKey' },
  { label: 'Secret', name: 'secret' },
  { label: 'Action', name: 'action' }
]

const CustomersSettings = props => {
  let tokens = getProp('tokens', props)
  tokens = tokens.filter(token => !token.revoked && token.name !== '__segment__internal__user__record__key') // ignore the internal user record key
  tokens.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))

  return (
    <div className={css.main}>
      <Body1>
         Personal access tokens function like ordinary OAuth access tokens.
         They can be used to fetch or write data into the User Record,
         depending on your permissions.
      </Body1>

      <Space value='20' />

      <Form onSubmit={props.onGenerateToken}>
        <InputField
          name='name'
          autofocus
          placeholder='Enter a description, e.g. Internal Support Sidebar'
          required
          label='Token Description' />

        <Space value='20' />

        <SubmitField
          disabled={props.isRequesting}
          loading={props.isRequesting}
          label='Generate token'
          labelLoading='Generating...' />
      </Form>

      <Space value='20' />

      <ShowHide show={tokens.length}>
        <Table
          columns={COLUMNS}
          sidePadding='20px'
          rows={tokens.map(token => {
            return {
              name: {
                value: token.name,
                content: <Display5>{token.name}</Display5>
              },
              accessKey: {
                value: token.access_key,
                content: <div className={css.accessKey}>{token.access_key}</div>
              },
              secret: {
                value: token.secret,
                content: token.secret ? <CopyButton text={token.secret} /> : <div className={css.secret}>&#8901;&#8901;&#8901;&#8901;&#8901;&#8901;&#8901;&#8901;&#8901;&#8901;</div>
              },
              action: {
                value: '',
                content: <Button size='small' onClick={() => props.onRevokeToken(token.access_key)}>Revoke</Button>
              }
            }
          })} />

        <Space value='20' />

        <Alert type='info'>
          <p>Make sure to copy your new personal token secret after creating. You won’t be able to see it again!</p>
        </Alert>
      </ShowHide>
    </div>
  )
}

CustomersSettings.displayName = 'CustomersSettings'

CustomersSettings.propTypes = {
  tokens: PropTypes.array.isRequired,
  onRevokeToken: PropTypes.func.isRequired,
  onGenerateToken: PropTypes.func.isRequired
}

export default CustomersSettings



// WEBPACK FOOTER //
// ./components/Customers/CustomersSettings.js